import { actions as segmentioActions } from '@saucelabs/sl-util-segmentio';

export const EVENTS = Object.freeze({
  ACCOUNT_EXPIRED_PAY_NOW_CLICK: 'account-expired/click/pay-now-button',
  ACCOUNT_EXPIRED_MODAL_SHOW: 'account-expired/show/modal',
});

export const trackEvent = segmentioActions.recordTrack;

export default trackEvent;
